import * as React from 'react';

import { common } from 'components/lexemes';
import { ExternalLink } from 'lib/app/external-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import Image from 'lib/image-container';
import LocaleContext from 'lib/locale-context';

export type AppLinksProps = {
  onAppleStoreClick?: () => void;
  onGoogleStoreClick?: () => void;
  description: string;
};

const AppLinks: React.FC<AppLinksProps> = ({
  onAppleStoreClick,
  onGoogleStoreClick,
  description,
}) => {
  const lang = React.useContext(LocaleContext);

  return (
    <div className="app-links" id="app-links">
      <div className="app-links__list">
        <a
          className={`app-links__link app-links__link--app-store app-links__link--app-store-${lang}`}
          href={ExternalLink.APP_STORE_IOS}
          onClick={onAppleStoreClick}
        >
          <Image
            src={`${CdnImagePath}/bumble/l-assets/${lang}/appstore-badge.svg`}
            unoptimized={true}
            width={120}
            height={40}
            alt={common.lxA11yAppStore}
          />
        </a>

        <a
          className={`app-links__link app-links__link--google-play app-links__link--google-play-${lang}`}
          href={ExternalLink.APP_STORE_ANDROID}
          onClick={onGoogleStoreClick}
        >
          <Image
            src={`${CdnImagePath}/bumble/l-assets/${lang}/google-play-badge.png`}
            fill={true}
            width={151}
            height={40}
            alt={common.lxA11yGooglePlay}
          />
        </a>
      </div>

      <p
        className="app-links__description"
        /* eslint-disable react/no-danger */
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </div>
  );
};

export default AppLinks;
